<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    components: {},
    computed: {},
};
</script>

<style>
@import './assets/external/normalize.css/normalize.css';
@import './assets/css/utils.css';
@import './assets/external/@fortawesome/fontawesome-free/css/all.min.css';
</style>
